// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__y5WFN","resendInfoText":"OnGoingPaymentBox_resendInfoText__Ww9WE"};